module.exports = __webpack_public_path__ + "img/share-tip.63927e89.png";